import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../httpService/httpService";

export const fetchFinancialGraph = createAsyncThunk(
  "/fetchFinancialGraph",
  async ( plan_id , { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.get(`/fetch-plan-comparison-conventional-digital/client-appsells/${plan_id}`, {
        
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.data || response.status !== 200) {
        throw new Error("Failed to fetch financials");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.message || "An error occurred while fetching financials"
      );
    }
  }
);

const fetchFinancialGraphSlice = createSlice({
  name: "fetchFinancialGraph",
  initialState: { 
    conventional_plan :{} ,
    digital_plan :{},
    status: "idle",
    error: null,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFinancialGraph.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(fetchFinancialGraph.fulfilled, (state, action) => {
        console.log("payload : " + JSON.stringify(action.payload)) ;
        state.status = "succeeded";
        state.conventional_plan = action.payload.conventional_plan;
        state.digital_plan = action.payload.digital_plan;
       
        state.loading = false;
      })
      .addCase(fetchFinancialGraph.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default fetchFinancialGraphSlice.reducer;
